import React, { useEffect, useRef } from 'react'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'

import { showErrorNotification } from '../../../core/helpers'

import { EditableTableRowLoader } from '../../../common/components/sections'

import { useBrandCurationTaskSelector } from '../../hooks'

const BrandCurationTaskEditableRow = ({ ...rowProps }) => {
  const rowRef = useRef(null)
  const { 'data-row-key': id, children, className, ...restProps } = rowProps
  const { isLoading, error } = useBrandCurationTaskSelector(id)

  useEffect(() => {
    if (!isNil(error)) {
      showErrorNotification({
        title: 'Brand curation task update failed',
        description: error,
      })
    }
  }, [error])

  return (
    <>
      <EditableTableRowLoader
        isLoading={isLoading}
        height={rowRef?.current?.offsetHeight}
      />
      <tr data-row-key={id} ref={rowRef} className={className} {...restProps}>
        {children}
      </tr>
    </>
  )
}

BrandCurationTaskEditableRow.propTypes = {
  rowProps: PropTypes.object,
}

BrandCurationTaskEditableRow.defaultProps = {
  rowProps: undefined,
}

export default BrandCurationTaskEditableRow
